import { useState, useEffect } from "react";

import API from "utils/api";

export default function useRules(id) {
  const [result, setResult] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    async function fetchRules() {
      setLoading(true);

      const { response, data } = await API.fetchRule(id);

      if (response.ok) {
        setResult(data);
        setError(null);
      } else {
        setError({ status: response.status, ...data });
      }

      setLoading(false);
    }

    if (id) {
      fetchRules();
    }
  }, [id]);

  return {
    loading,
    error,
    rule: result,
  };
}
